import { handleActions } from 'redux-actions';
import {
  fetchOrderHistoryList,
  setOrderHistoryError,
  setOrderHistoryFilters,
  setOrderHistoryList,
} from './actions';

const defaultState = {
  loading: false,
  filters: {
    pageNumber: 1,
    pageSize: 10,
    sortBy: '',
    search: '',
    isSortOrderDescending: false,
    status: null,
  },
  totalRecords: 0,
  data: [],
  options: [],
  error: null,
};

export default handleActions(
  {
    [fetchOrderHistoryList](state) {
      return {
        ...state,
        loading: true,
        data: [],
      };
    },
    [setOrderHistoryList](state, { payload }) {
      return {
        ...state,
        loading: false,
        data: payload?.data?.records,
        totalRecords: payload?.data?.totalRecords,
        error: null,
      };
    },
    [setOrderHistoryError](state, { payload }) {
      return {
        ...state,
        data: [],
        loading: false,
        totalPages: defaultState.totalPages,
        error: payload?.message,
      };
    },
    [setOrderHistoryFilters](state, { payload }) {
      return {
        ...state,
        filters: {
          ...state.filters,
          ...payload,
        },
      };
    },
  },
  defaultState,
);
